import { render } from "./CustomerVoice_M_2.vue?vue&type=template&id=718ac753"
import script from "./CustomerVoice_M_2.vue?vue&type=script&lang=js"
export * from "./CustomerVoice_M_2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__